/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_AnalysisInputs */

const en_task_flow_analysis = /** @type {(inputs: Task_Flow_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run AI analysis when created`)
};

const pt_br2_task_flow_analysis = /** @type {(inputs: Task_Flow_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Executar análise de IA ao criar`)
};

/**
* | output |
* | --- |
* | "Run AI analysis when created" |
*
* @param {Task_Flow_AnalysisInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_analysis = /** @type {((inputs?: Task_Flow_AnalysisInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_AnalysisInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_analysis(inputs)
	return pt_br2_task_flow_analysis(inputs)
});